import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { token, user, logout } = useAuth();
  const location = useLocation();

  return (
    <div>
      <nav
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "1rem",
          backgroundColor: "#f0f0f0",
          marginBottom: "2rem",
        }}
      >
        <div>
          <Link
            to="/"
            style={{
              fontWeight: "bold",
              fontSize: "1.2rem",
              textDecoration: "none",
              color: "#333",
            }}
          >
            My App
          </Link>
        </div>

        <div>
          {token && user ? (
            <>
              <Link
                to="/dashboard"
                style={{
                  marginRight: "1rem",
                  textDecoration:
                    location.pathname === "/dashboard" ? "underline" : "none",
                }}
              >
                Dashboard
              </Link>
              <Link
                to="/tasks"
                style={{
                  marginRight: "1rem",
                  textDecoration: location.pathname.startsWith("/tasks")
                    ? "underline"
                    : "none",
                }}
              >
                Tasks
              </Link>
              <Link
                to="/profile"
                style={{
                  marginRight: "1rem",
                  textDecoration:
                    location.pathname === "/profile" ? "underline" : "none",
                }}
              >
                Profile
              </Link>
              <button onClick={logout} style={{ cursor: "pointer" }}>
                Logout
              </button>
            </>
          ) : (
            <>
              <Link
                to="/login"
                style={{
                  marginRight: "1rem",
                  textDecoration:
                    location.pathname === "/login" ? "underline" : "none",
                }}
              >
                Login
              </Link>
              <Link
                to="/register"
                style={{
                  textDecoration:
                    location.pathname === "/register" ? "underline" : "none",
                }}
              >
                Register
              </Link>
            </>
          )}
        </div>
      </nav>

      <main style={{ padding: "0 1rem" }}>{children}</main>
    </div>
  );
};

export default Layout;
